import { fetcher } from '@commenda/utils';
import { CreateTPDocumentRecordParams, TTPDocumentRecord } from './types';

type CreateTPDocumentRecordResult =
  | { ok: true; data: TTPDocumentRecord }
  | { ok: false; error: string };

const createTPDocumentRecord = async (
  body: CreateTPDocumentRecordParams
): Promise<CreateTPDocumentRecordResult> => {
  const res = await fetcher('tp-document-record', {
    method: 'POST',
    body,
  });

  if (!res.ok) {
    return { ok: false, error: 'Failed to create document record' };
  }

  const data = (await res.json()) as TTPDocumentRecord;
  return { ok: true, data };
};

export { createTPDocumentRecord };
export type { CreateTPDocumentRecordResult };
